import React from 'react';
import SEO from '../../../../components/SEO/SEO';

import { Link } from 'react-router-dom';
import './AllInOneHealthcare.css';

const AllInOneHealthcare = () => {
    const healthcareAllInOneServices = [
        {
            id: 'integrated-strategy',
            icon: '🎯',
            title: 'Integrated Healthcare Marketing Strategy',
            description: 'Comprehensive marketing strategy that aligns all channels for your healthcare practice.',
            link: '/services/gohighlevel'
        },
        {
            id: 'performance-tracking',
            icon: '📊',
            title: 'Performance Tracking & Analytics',
            description: 'Complete analytics and reporting across all marketing channels with HIPAA-compliant tracking.',
            link: '/services/gohighlevel'
        },
        {
            id: 'automation-crm',
            icon: '🔄',
            title: 'Patient Communication Automation',
            description: 'Streamline your patient communication and marketing processes with automated workflows.',
            link: '/services/gohighlevel'
        },
        {
            id: 'growth-optimization',
            icon: '📈',
            title: 'Growth Optimization',
            description: 'Continuous optimization to maximize your marketing ROI and patient acquisition.',
            link: '/services/gohighlevel'
        }
    ];

    return (
        <div className="seo-services-page">
            <SEO 
                title="All In One Healthcare Services | Digi Network" 
                description="Learn more about our All In One Healthcare services to grow your business online with Digi Network." 
                canonical="/industries/healthcare/services/allinonehealthcare" 
            />

            {/* Hero Section */}
            <section className="seo-hero">
                <div className="seo-hero-bg"></div>
                <div className="container">
                    <div className="seo-hero-content">
                        
                        <h1>Complete Digital Marketing for Healthcare Practices</h1>
                        <p className="industry-service-hero-description">Comprehensive digital marketing solutions tailored for healthcare businesses. Our all-in-one approach combines SEO, paid ads, web development, and email marketing for maximum patient acquisition and retention.</p>
                        <div className="industry-service-hero-cta">
                            <Link to="/contact" className="btn btn-primary">
                            Get Free Marketing Audit
                            <svg width="25" height="23" viewBox="0 0 25 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M24.4766 12.1562L14.8516 21.7812C14.5234 22.1094 13.9219 22.1094 13.5938 21.7812C13.2656 21.4531 13.2656 20.8516 13.5938 20.5234L21.7422 12.375H1.125C0.632812 12.375 0.25 11.9922 0.25 11.5C0.25 11.0625 0.632812 10.625 1.125 10.625H21.7422L13.5938 2.53125C13.2656 2.20312 13.2656 1.60156 13.5938 1.27344C13.9219 0.945312 14.5234 0.945312 14.8516 1.27344L24.4766 10.8984C24.8047 11.2266 24.8047 11.8281 24.4766 12.1562Z" fill="white"/>
                            </svg>
                        </Link>
                        </div>
                    </div>
                </div>
            </section>

            {/* Healthcare All-in-One Services Grid */}
            <section className="seo-services-grid-section">
                <div className="container">
                    <h2>Our Healthcare All-in-One Marketing Services</h2>
                    <p>Comprehensive marketing solutions designed specifically for healthcare practices</p>

                    <div className="seo-services-grid">
                        {healthcareAllInOneServices.map((service) => (
                            <Link to={service.link} key={service.id} className="seo-service-card">
                                <div className="seo-service-icon">{service.icon}</div>
                                <h3>{service.title}</h3>
                                <p>{service.description}</p>
                                <div className="learn-more">
                                    Learn More
                                    <svg width="20" height="20" viewBox="0 0 25 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M24.4766 12.1562L14.8516 21.7812C14.5234 22.1094 13.9219 22.1094 13.5938 21.7812C13.2656 21.4531 13.2656 20.8516 13.5938 20.5234L21.7422 12.375H1.125C0.632812 12.375 0.25 11.9922 0.25 11.5C0.25 11.0625 0.632812 10.625 1.125 10.625H21.7422L13.5938 2.53125C13.2656 2.20312 13.2656 1.60156 13.5938 1.27344C13.9219 0.945312 14.5234 0.945312 14.8516 1.27344L24.4766 10.8984C24.8047 11.2266 24.8047 11.8281 24.4766 12.1562Z" fill="currentColor"/>
                                    </svg>
                                </div>
                            </Link>
                        ))}
                    </div>
                </div>
            </section>

            {/* Why Healthcare All-in-One Marketing Matters */}
            <section className="why-seo-matters">
                <div className="container">
                    <div className="why-seo-content">
                        <div className="why-seo-text">
                            <h2>Why Healthcare Practices Need All-in-One Marketing</h2>
                            <div className="why-seo-points">
                                <div className="why-point">
                                    <h4>🏥 Comprehensive Patient Acquisition</h4>
                                    <p>Reach patients through multiple channels - search, social media, email, and more - for maximum visibility.</p>
                                </div>
                                <div className="why-point">
                                    <h4>💰 Cost-Effective Growth</h4>
                                    <p>Integrated marketing strategies reduce costs while maximizing patient acquisition and retention.</p>
                                </div>
                                <div className="why-point">
                                    <h4>🔒 HIPAA Compliance</h4>
                                    <p>All marketing activities are designed with HIPAA compliance in mind, protecting patient privacy.</p>
                                </div>
                                <div className="why-point">
                                    <h4>📊 Unified Analytics</h4>
                                    <p>Track all marketing efforts in one place with comprehensive reporting and analytics.</p>
                                </div>
                            </div>
                        </div>
                        <div className="why-seo-visual">
                            <div className="seo-visual-placeholder">
                                <p>🖼️ Add Healthcare All-in-One Marketing Impact Graphic</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* Process Section */}
            <section className="seo-process">
                <div className="container">
                    <div className="section-header">
                        <div className="label">OUR APPROACH</div>
                        <h2>Our All-in-One Marketing Process</h2>
                        <p>A proven methodology designed specifically for healthcare businesses</p>
                    </div>

                    <div className="process-grid">
                        <div className="process-step">
                            <div className="process-number">01</div>
                            <h3>Complete Analysis</h3>
                            <p>Audit all aspects of your marketing to identify opportunities across channels.</p>
                        </div>
                        <div className="process-step">
                            <div className="process-number">02</div>
                            <h3>Integrated Strategy</h3>
                            <p>Develop a unified marketing plan that leverages all channels synergistically.</p>
                        </div>
                        <div className="process-step">
                            <div className="process-number">03</div>
                            <h3>Multi-Channel Launch</h3>
                            <p>Execute campaigns across all platforms simultaneously for maximum impact.</p>
                        </div>
                        <div className="process-step">
                            <div className="process-number">04</div>
                            <h3>Unified Optimization</h3>
                            <p>Monitor all channels, optimize performance, and scale successful strategies.</p>
                        </div>
                    </div>
                </div>
            </section>


            {/* Healthcare All-in-One Process */}

            {/* Benefits Section */}

            {/* Case Studies Section */}
            <section className="case-studies-section">
                <div className="container">
                    <h2>Healthcare All-in-One Marketing Success Stories</h2>
                    <p>Real results from our healthcare marketing campaigns</p>
                    <div className="case-studies-grid">
                        <div className="case-study-item">
                            <div className="case-study-metric">400%</div>
                            <h3>Increase in New Patients</h3>
                            <p>Medical practice saw 400% increase in new patient appointments within 8 months of our all-in-one marketing campaign.</p>
                        </div>
                        <div className="case-study-item">
                            <div className="case-study-metric">250%</div>
                            <h3>More Website Traffic</h3>
                            <p>Healthcare practice increased website traffic by 250% through integrated SEO and paid advertising.</p>
                        </div>
                        <div className="case-study-item">
                            <div className="case-study-metric">80%</div>
                            <h3>Reduction in No-Shows</h3>
                            <p>Medical practice reduced no-show rates by 80% through automated appointment reminders and patient communication.</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* CTA Section */}
            <section className="industry-service-cta">
                <div className="container">
                    <h2>Ready to Transform Your Healthcare Practice with All-in-One Marketing?</h2>
                    <p>Get a free marketing audit and discover how we can help you attract more patients and grow your practice.</p>
                    <Link to="/contact" className="btn btn-primary">
                        Get Your Free Marketing Audit
                        <svg width="25" height="23" viewBox="0 0 25 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M24.4766 12.1562L14.8516 21.7812C14.5234 22.1094 13.9219 22.1094 13.5938 21.7812C13.2656 21.4531 13.2656 20.8516 13.5938 20.5234L21.7422 12.375H1.125C0.632812 12.375 0.25 11.9922 0.25 11.5C0.25 11.0625 0.632812 10.625 1.125 10.625H21.7422L13.5938 2.53125C13.2656 2.20312 13.2656 1.60156 13.5938 1.27344C13.9219 0.945312 14.5234 0.945312 14.8516 1.27344L24.4766 10.8984C24.8047 11.2266 24.8047 11.8281 24.4766 12.1562Z" fill="white"/>
                        </svg>
                    </Link>
                </div>
            </section>
        </div>
    );
};

export default AllInOneHealthcare;
